/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCodeShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9.931 8.682 8.47 7.318 3.632 12.5l4.837 5.182 1.462-1.364L6.368 12.5l3.563-3.818zm4.139 0 3.562 3.818-3.563 3.818 1.462 1.364 4.837-5.182-4.837-5.182-1.462 1.364zM19 18v2h2.027a7.55 7.55 0 0 1-1.388 1.084C18.613 21.711 17.615 22 17 22v2c1.1 0 2.458-.461 3.682-1.21A9.714 9.714 0 0 0 22 21.826V24h2v-6h-5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCodeShortcut as CodeShortcut };
